import React from "react";
import searchIcon from "assets/images/fileImage/search.svg";
import close from "assets/images/adduser/cross.svg";
import closeDark from "assets/images/adduser/crossDark.svg";
import "./input.scss";
import useTheme from "hooks/observer";

const Input = ({
  star = "",
  label = "",
  type = "text",
  value = "",
  placeholder = "",
  width = "50%",
  searchIconBool = false,
  onChange = () => {},
  onKeyDown = () => {}, // NEW
  bg = "",
  clear = false,
  wrapWidth = "100%",
  handleClear = () => {},
  left = "12px",
  height = "",
  inputName,
  errorMessage = "",
  maxLength = 80,
  paddingLeft = "",
  mockClass,
  autoFocus= false,
  disabled = false,
}) => {
  const theme = useTheme();
  return (
    <div className={`inputContainer ${mockClass}`}>
      {label && (
        <p className="label">
          {label} <span>{star}</span>
        </p>
      )}

      <div
        className="inputWrapper"
        style={{
          backgroundColor: theme == "dark" ? "transparent" : "#fff",
          border: errorMessage ? "1px solid  var(--accent-colors-red)" : "",
        }}
      >
        {searchIconBool && (
          <img src={searchIcon} alt="Search" className="searchIcon" />
        )}

        <input
        disabled={disabled}
          name={inputName}
          style={{
            width: width,
            backgroundColor: bg,
            height: height,
            paddingLeft: paddingLeft,
          }}
          type={type}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown} 
          maxLength={maxLength}
          autoFocus={autoFocus}
        />

        {clear && (
          <img
            src={theme == "light" ? close : closeDark}
            alt="clear"
            className="remove"
            onClick={handleClear}
          />
        )}
      </div>
      {errorMessage && <p className="errorMessage">{errorMessage}</p>}
    </div>
  );
};

export default Input;
